import { render, staticRenderFns } from "./PTopHeroYouTubeSlider.vue?vue&type=template&id=b1d237b6&"
import script from "./PTopHeroYouTubeSlider.vue?vue&type=script&lang=js&"
export * from "./PTopHeroYouTubeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports